<script>
import { storeToRefs } from 'pinia';
import { useVisitStore } from '../../../store/contact/VisitStore';

export default {
    setup() {
        const store = useVisitStore();
        const { totalSteps, currentStep } = storeToRefs(store);
        return {
            totalSteps,
            currentStep,
        };
    },
};
</script>
<template>
    <div
        class="steps-list"
        style="--active-color: #7c826b; --passive-color: #cfd0d0"
    >
        <ul>
            <li
                :class="currentStep === step ? 'step-active' : ''"
                v-for="step in totalSteps"
            >
                <div class="step-count">{{ step }}</div>
            </li>
        </ul>
    </div>
</template>
